import Overview from './overview'

export default function Dashboard() {
  return <Overview isDashboard />
}
